import { DateTime, FixedOffsetZone } from 'luxon';

const FALLBACK_ZONE = 'Asia/Shanghai';

function isValidLuxonZone(zone: string): boolean {
  if (!zone || /\s/.test(zone)) return false;
  return DateTime.now().setZone(zone).isValid;
}

/**
 * 只取店铺时区里的 IANA。没有合法 IANA 则返回空串，不猜 GMT 偏移。
 */
export function resolveShopLuxonZone(timezoneRaw?: string | null): string {
  const raw = String(timezoneRaw || '').trim();
  if (!raw) return '';

  let ianaCandidate = raw;
  if (raw.startsWith('(')) {
    const end = raw.indexOf(')');
    if (end > 1) {
      ianaCandidate = raw.slice(end + 1).trim();
    }
  }

  if (isValidLuxonZone(ianaCandidate)) {
    return ianaCandidate;
  }

  if (isValidLuxonZone(raw)) {
    return raw;
  }

  return '';
}

/**
 * 展示名时区（如 "(GMT-05:00) Eastern Time (US & Canada)"）没有 IANA，
 * 用括号里的 GMT 偏移构造 Luxon 固定时区，避免生成 "Invalid DateTime"。
 */
function resolveGmtOffsetZone(timezoneRaw?: string | null): string {
  const matched = String(timezoneRaw || '').match(/GMT\s*([+-])(\d{1,2}):?(\d{2})?/i);
  if (!matched) return '';
  const sign = matched[1] === '-' ? -1 : 1;
  const hours = Number(matched[2] || 0);
  const minutes = Number(matched[3] || 0);
  return FixedOffsetZone.instance(sign * (hours * 60 + minutes)).name;
}

function resolveShopFormatZone(timezoneRaw?: string | null): string {
  return resolveShopLuxonZone(timezoneRaw) || resolveGmtOffsetZone(timezoneRaw) || FALLBACK_ZONE;
}

export function formatShopNow(format: string, timezoneRaw?: string | null, minusDays = 0): string {
  let dt = DateTime.now().setZone(resolveShopFormatZone(timezoneRaw));
  if (!dt.isValid) return '';
  if (minusDays) {
    dt = dt.minus({ days: minusDays });
  }
  const out = dt.toFormat(format);
  return out === 'Invalid DateTime' ? '' : out;
}

export function toShopListDateParam(value?: string | null): string {
  if (!value || value === 'Invalid DateTime') return '';
  return value;
}

export function hasShopListDateParams(
  startDate?: string | null,
  endDate?: string | null
): boolean {
  return Boolean(toShopListDateParam(startDate) && toShopListDateParam(endDate));
}
